import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Fade } from '@mui/material';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { useAlert } from 'src/hooks';
import FilterList from './FilterList';
import CampaignTypeItem from '../CampaignTypeItem';
import { checkRecipeCfgValidity } from 'src/reducers/campaignEditor';
import { SMARTJ_CMP_CONTENT, SMARTJ_CMP_INFOS } from '../../CampaignEditor';

const CampaignTarget = ({
  editedCampaign,
  selectedType,
  requestModelByRMTypeId,
  recipesById,
  goToEditorStep,
  doSaveCampaign,
  recipeCfgValidity,
}) => {
  const { showAlert } = useAlert();
  const { t } = useTranslation();
  return (
    <Fade in timeout={500}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '16px 24px',
        }}
      >
        <CampaignTypeItem
          disabledSelect
          typeItem={
            editedCampaign.recipeId
              ? requestModelByRMTypeId[recipesById[editedCampaign.recipeId].requestModelTypeId]
              : selectedType
          }
        />
        <FilterList recipeCfgValidity={recipeCfgValidity} />
        <div style={{ textAlign: 'right', paddingTop: '12px' }}>
          <Button
            style={{ margin: '2px' }}
            variant="text"
            color="primary"
            onClick={e => {
              e.preventDefault();
              goToEditorStep(SMARTJ_CMP_INFOS);
            }}
          >
            {t('smartmessaging.buttonLabel.previous')}
          </Button>
          <Button
            style={{ margin: '2px' }}
            variant="contained"
            color="primary"
            onClick={e => {
              e.preventDefault();
              const saveAndNext = async () => {
                if (editedCampaign.isWritable) await doSaveCampaign(true, showAlert);
                goToEditorStep(SMARTJ_CMP_CONTENT);
              };
              saveAndNext();
            }}
            disabled={!recipeCfgValidity.isValid}
          >
            {t('smartmessaging.buttonLabel.next')}
          </Button>
        </div>
      </div>
    </Fade>
  );
};

const mapStateToProps = state => ({
  recipeCfgValidity: checkRecipeCfgValidity(state),
});

CampaignTarget.propTypes = {
  editedCampaign: PropTypes.object.isRequired,
  selectedType: PropTypes.object,
  requestModelByRMTypeId: PropTypes.object.isRequired,
  recipesById: PropTypes.object.isRequired,
  goToEditorStep: PropTypes.func.isRequired,
  doSaveCampaign: PropTypes.func.isRequired,
  recipeCfgValidity: PropTypes.object.isRequired,
};

CampaignTarget.defaultProps = {
  selectedType: PropTypes.object,
};

export default connect(mapStateToProps)(CampaignTarget);
